import createMetadataAPIActions from '../../utils/api-metadata-actions';
import types from './types';

const options = {
  name: 'activePeriods',
  baseType: 'ACTIVE_PERIODS',
  apiEndpoint: 'active_periods'
};

const actions = createMetadataAPIActions(options);

const clearActivePeriods = (userId, groupId) => ({
  type: types.CLEAR_ACTIVE_PERIODS,
  payload: { userId, groupId }
});

export default {
  ...actions,
  clearActivePeriods
};
